import {sanitizeDigits} from '../../lib/sanitize-digits';
import {FieldInput} from '../FieldInput';
import {Icon} from '../Icon';

import type {FieldInputProps} from '../FieldInput';
import type {ChangeEvent} from 'react';

export interface IsraeliIdFieldProps extends Omit<
  FieldInputProps,
  'value' | 'onChange' | 'inputMode' | 'type' | 'maxLength'
> {
  value: string;
  /** Omit for a read-only/display-only field (e.g. paired with `disabled`). */
  onChange?: (raw: string) => void;
}

const ISRAELI_ID_LENGTH = 9;

/**
 * Shared 9-digit masked input backing `NationalIdField` and `CorpIdField` — the two share
 * every rendering/masking concern and differ only in which validator the caller applies.
 */
export function IsraeliIdField({
  value,
  onChange,
  startAdornment,
  ...fieldInputProps
}: IsraeliIdFieldProps) {
  return (
    <FieldInput
      {...fieldInputProps}
      startAdornment={startAdornment ?? <Icon name="shield" className="size-4" />}
      value={value}
      onChange={
        onChange
          ? (e: ChangeEvent<HTMLInputElement>) =>
              onChange(sanitizeDigits(e.target.value, ISRAELI_ID_LENGTH))
          : undefined
      }
      inputMode="numeric"
    />
  );
}
